import React, { useEffect, useRef, useState } from "react";
import "./QuizTestLayout.css";
import { genTaskApi } from "../../../api/genTaskApi";
import { useLocation, useNavigate } from "react-router-dom";
import AlertMessage from "../../../components/common/AlertMessage";

export default function ExamDetailView() {
    const [questionsData, setQuestionsData] = useState([]);
    const [alert, setAlert] = useState({ type: "", message: "" });
    const { state } = useLocation();
    const navigate = useNavigate();
    const refs = useRef([]);

    // Determine style class for each choice
    const getChoiceClass = (q, choice) => {
        const isCorrect = choice === q.correctAnswer;
        const isUserPick = choice === q.submittedAnswer;

        if (isCorrect && isUserPick) return "choice correct selected";
        if (isCorrect) return "choice correct";
        if (isUserPick && !isCorrect) return "choice wrong";
        return "choice";
    };

    const scrollToQuestion = (index) => {
        refs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    useEffect(() => {
        if (!state?.taskId) return;
        loadData(state.taskId, state?.attemptId);
    }, [state?.attemptId, state?.taskId]);

    const fetchFieldValues = async (taskId, attemptId) => {
        if (attemptId) {
            const resByAttempt = await genTaskApi.getSubmitByAttempt(attemptId);
            return resByAttempt?.success ? resByAttempt.data || [] : [];
        }
        const res = await genTaskApi.getSubmit(taskId);
        return res?.success ? res.data || [] : [];
    };

    const loadData = async (taskId, attemptId) => {
        try {
            const res = await genTaskApi.taskDetail(taskId);
            const submitted = await fetchFieldValues(taskId, attemptId);

            if (res?.success) {
                const merged = (res.data || []).map((x, idx) => ({
                    id: x.questionId ?? idx + 1,
                    text: x.text ?? "",
                    choices: Array.isArray(x.choice) ? x.choice : [],
                    correctAnswer: x.correctAnswer,
                    submittedAnswer:
                        submitted.find((s) => s.questionId === x.questionId)?.value || null
                }));

                setQuestionsData(merged);
                refs.current = [];
            }
        } catch (err) {}
    };
    const handleOnSubmit = async () => {
        // ...
        navigate("/exam/category");
    };

    return (
        <div className="container mt-4">
            <AlertMessage
                message={alert.message}
                type={alert.type}
                onClose={() => setAlert({ type: "", message: "" })}
            />
            {state?.attemptNumber && (
                <div className="mb-3 text-muted">
                    Viewing Attempt #{state.attemptNumber}
                </div>
            )}

            <div className="row">
                {/* LEFT SIDE */}
                <div className="col-md-8">
                    <div className="quiz-scroll">
                        {questionsData.map((q, idx) => (
                            <div
                                className="q-item"
                                key={q.id}
                                ref={(el) => (refs.current[idx] = el)}
                            >
                                <h5 className="fw-bold mb-3">
                                    {idx + 1}. {q.text}
                                </h5>

                                {q.choices.map((choice, ci) => (
                                    <div key={ci} className={getChoiceClass(q, choice)}>
                                        <span>{choice}</span>

                                        {/* Icons */}
                                        {choice === q.correctAnswer && (
                                            <i className="bi bi-check-circle-fill text-success ms-2"></i>
                                        )}
                                        {choice === q.submittedAnswer &&
                                            choice !== q.correctAnswer && (
                                                <i className="bi bi-x-circle-fill text-danger ms-2"></i>
                                            )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    <button className="btn btn-danger finish-btn mt-3" onClick={handleOnSubmit}>
                        Close
                    </button>
                </div>

                {/* RIGHT SIDE */}
                <div className="col-md-4">
                    <div className="card shadow-sm p-3">
                        <h6 className="fw-bold mb-3">Question State</h6>

                        <div className="row g-2">
                            {questionsData.map((q, idx) => {
                                const status = q.correctAnswer == q.submittedAnswer ? "correct" : "not-correct";

                                return (
                                    <div className="col-3" key={q.id}>
                                        <div
                                            className={`q-status-box ${status}`}
                                            onClick={() => scrollToQuestion(idx)}
                                        >
                                            {idx + 1}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
